import { useLayoutShortcut } from '@/store';
import type { TItem } from '@/components/GridBoards/types';
import { createShortcut } from '../layoutItems';

type ReturnOfUseShortcuts = [TItem[], (arg: TItem[]) => void];

const useShortcuts = (
  screen: number,
  siderbounds: LayoutBoxSiderbounds,
): ReturnOfUseShortcuts => {
  const [shortcut = [], updateLayoutShortcut] = useLayoutShortcut();
  const curScreenSC = shortcut.filter((sc) => {
    return sc.screen === screen;
  });

  const result = curScreenSC.map((sc) => {
    return createShortcut(
      {
        x: sc.x,
        y: sc.y,
        title: sc.title,
        screen: sc.screen,
        url: sc.url,
      },
      siderbounds,
    );
  });

  const updateShortcuts = (items: TItem[]) => {
    const tmp: PropType<ConfigLayout, 'shortcut'> = [];
    items.forEach((i) => {
      if (i.id === 'shortcut') {
        tmp.push({
          screen: screen,
          x: i.x,
          y: i.y,
          title: i.title || '',
          url: i.url || '',
        });
      }
    });
    const _sc = shortcut.filter((sc) => sc.screen !== screen);

    updateLayoutShortcut([..._sc, ...tmp]);
  };

  return [result, updateShortcuts];
};

export default useShortcuts;
